var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full flex items-center justify-center"},[_c('div',{staticClass:"flex"},[_c('magnifying-glass-icon',{staticClass:"w-10 h-10 mr-3",attrs:{"color":"#686b79"}}),_c('span',{staticClass:"font-bold text-2xl"},[_vm._v("No se encontraron resultados")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }